<template>
	<div>
		<loading v-if="!loaded" />
		<el-tabs v-model="tabName" v-if="loaded">
			<el-tab-pane label="ការរំលោះទាំងអស់" name="first"></el-tab-pane>
		</el-tabs>
		<div v-if="tabName == 'first' && loaded">
			<div class="md-layout">
				<div class="md-layout-item md-small-size-100 md-size-30">
					<md-field>
						<label>ស្វែងរករំលោះដោយឈ្មោះអតិថិជន ឬលេខកូដរំលោះ</label>
						<md-input v-model="search.text" type="text" @keyup.enter="searchHandler()"></md-input>
					</md-field>
				</div>
				<div class="md-layout-item md-small-size-100 md-size-25">
					<md-field>
						<label>ស្ថានភាពរំលោះ</label>
						<md-select placeholder="ស្ថានភាពរំលោះ (ទាំងអស់)" v-model="search.status">
							<md-option value="">ទាំងអស់</md-option>
							<md-option value="act">កំពុងដំណើរការ</md-option>
							<md-option value="fin">បានបញ្ចប់</md-option>
						</md-select>
					</md-field>
				</div>
				<div class="md-layout-item md-small-size-100 md-size-25">
					<md-field>
						<label>គម្រោង</label>
						<md-select placeholder="គម្រោង (ទាំងអស់)" v-model="search.project">
							<md-option value="">ទាំងអស់</md-option>
							<md-option v-for="project in projectList" :value="project.id">{{project.name}}</md-option>
						</md-select>
					</md-field>
				</div>
				<div class="md-layout-item md-size-20">
					<md-button class="md-raised md-primary" @click="searchHandler()" style="width: 100%">ស្វែងរក</md-button>
				</div>
			</div>
			<md-table v-if="loanList.length > 0">
				<md-table-row>
					<md-table-head>ល.រ</md-table-head>
					<md-table-head>លេខកូដ</md-table-head>
					<md-table-head>អតិថិជន</md-table-head>
					<md-table-head>លេខឡូតិ៍</md-table-head>
					<md-table-head>ចំនួនខែបង់</md-table-head>
					<md-table-head>ការប្រាក់ និងប្រាក់ដើម</md-table-head>
					<md-table-head>ថ្ងៃបង់ប្រាក់បន្ទាប់</md-table-head>
					<md-table-head>ស្ថានភាព</md-table-head>
					<md-table-head>សកម្មភាព</md-table-head>
				</md-table-row>

				<md-table-row v-for="(loan, index) in loanList">
					<md-table-cell>{{ index + 1 }}</md-table-cell>
					<md-table-cell><b>{{ loan.hash }}</b><br>{{ config.datelify(loan.created_date) }}</md-table-cell>

					<md-table-cell><b>{{loan.client_hash}}</b><br>{{loan.client_name}}</md-table-cell>
					<md-table-cell>{{loan.lot}}<br>{{loan.project_name}}</md-table-cell>
					<md-table-cell><b>{{loan.total_paid_term - 1}} / {{loan.total_term - 1}}</b></md-table-cell>
					<md-table-cell>
						{{config.moneylify(loan.total_paid_interest)}} / <b>{{(config.moneylify(loan.total_interest))}}</b><br>
						{{config.moneylify(loan.total_paid_principal)}} / <b>{{(config.moneylify(loan.total_principal))}}</b></md-table-cell>
					<md-table-cell>
						<span v-if="loan.total_paid_term == loan.total_term || loan.status == 'fin'" class="active">មិនមាន</span>
						<span class="late"
							v-else-if="String(loan.next_payment).length >0 && config.timelify(loan.next_payment) == 'ហួសកំណត់'">{{config.datelifyShort(loan.next_payment)}}</span>
						<span class="active"
							v-else-if="String(loan.next_payment).length >0">{{config.datelifyShort(loan.next_payment)}}
							({{config.timelify(loan.next_payment)}})</span>
					</md-table-cell>
					<md-table-cell>
						<span class="active" v-if="loan.status == 'act'">{{config.getStatus(loan.status)}}</span>
						<span class="late" v-if="loan.status == 'fin'">{{config.getStatus(loan.status)}}</span>
					</md-table-cell>
					<md-table-cell>
						<router-link :to="'/loans/detail/' + loan.hash">
							<md-button class="md-just-icon md-simple md-success">
								<md-icon>visibility</md-icon>
								<md-tooltip md-direction="top">មើលលម្អិត</md-tooltip>
							</md-button>
						</router-link>
						<router-link :to="'/loans/edit/' + loan.hash">
							<md-button class="md-just-icon md-simple md-primary">
								<md-icon>edit</md-icon>
								<md-tooltip md-direction="top">កែប្រែរំលោះ</md-tooltip>
							</md-button>
						</router-link>
						<md-button class="md-just-icon md-simple md-danger" @click="showDeleteAction(loan.hash)" v-if="$store.state.authentication.account_type == 'sa'">
							<md-icon>delete</md-icon>
							<md-tooltip md-direction="top">លុបការរំលោះនេះ</md-tooltip>
						</md-button>
					</md-table-cell>
				</md-table-row>
			</md-table>
			<h4 class="text-center" v-if="loanList.length == 0 && loaded == true">មិនមានរំលោះទេ។</h4>
			<div class="places-buttons text-right" v-if="loadMore" >
				<md-button class="md-primary" @click="searchHandler(true)">បង្ហាញបន្ថែម</md-button>
			</div>
		</div>

		<md-dialog-confirm :md-active.sync="deleteDialogActive" md-title="តើអ្នកពិតជាចង់លុបការរំលោះនេះមែនឬ​ ?"
			md-content="ការរំលោះនេះនឹងត្រូវបានលុប។" md-confirm-text="លុប" md-cancel-text="បោះបង់"
			@md-cancel="onCancel" @md-confirm="onDelete" />
	</div>

</template>

<script>
	import { Datetime } from 'vue-datetime';
	export default {
		components: { Datetime },
		created() {
			this.searchHandler();
			this.searchProject();
			// this.getLocation();
			// this.getSettings();
			// this.searchHandler();
		},

		data() {
			return {
				tabName: "first",
				loaded: false,
				loadMore: false,
				deleteDialogActive: false,
				deleteSelected: '',
				search: {
					text: "",
					status: "",
					project: ""
				},
				loadMore: true,
				loanList: [],
				projectList: []
			}
		},
		methods: {
			searchHandler(more = false) {
				this.$http.post(this.config.api + "/admin/loan/search", {
					text: this.search.text,
					status: this.search.status,
					project: this.search.project,
					offset: more ? this.loanList.length : 0
				}).then(data => {
					this.loaded = true;
					this.search.text = "";
					this.loanList = more ? this.loanList.concat(data.body.data) : data.body.data;
					if (data.body.data.length == 100) this.loadMore = true
					else this.loadMore = false
				})
			},
			searchProject(more = false) {
				this.$http.post(this.config.api + "/admin/project/search", {
					text: ""
				}).then(data => {
					this.projectList = data.body.data
				})
			},
			showDeleteAction(id) {
				this.deleteSelected = id
				this.deleteDialogActive = true
			},
			onDelete() {
				this.$http.post(this.config.api + "/admin/loan/delete", {
					hash: this.deleteSelected
				}).then(res => {
					if (res.body.status == 'success') {
						this.$notification.notify({
							message: "រំលោះត្រូវបានលុបដោយជោគជ័យ។",
							icon: 'done',
							type: 'success'
						})
						this.searchHandler();
						this.onCancel();
					}
				})
			},
			onCancel() {
				this.deleteSelected = ""
				this.deleteDialogActive = false
			}
		}
	}
</script>
<style scoped>
	.product-thumbnail {
		width: 64px;
		height: 64px;
	}

	.grid-8 {
		text-align: center;
		max-width: 20%;
		min-width: 20%;
		flex: 0 0 20%;
	}

	.thumb-product {
		width: 50%;
	}
</style>



// WEBPACK FOOTER //
// src/pages/Loans/View.vue